import GlobalStyle from './theme/global';
import Home from './components/Home';

function App() {
	return (
		<>
			<Home />
			<GlobalStyle />
		</>
	);
}

export default App;
